/**
 * @description: 取酒汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="war-qjh-report">
        <div class="qh-list">
            <el-form :inline="true" size="small" :model="qh_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="qh_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="qh_list_form.start_date"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="qh_list_form.end_date"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="qh_list_form.shop_id" filterable clearable placeholder="请选择门店" @change="getRoomArea">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="区域">
                    <el-select v-model="qh_list_form.room_area_name" filterable clearable placeholder="请选择区域" :disabled="qh_list_form.room_area_disabled" @change="qhRoomArea">
                        <el-option v-for="item in room_area_list" :key="item.id" :label="item.name" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-select v-model="qh_list_form.goods_type" filterable clearable placeholder="请选择商品类型">
                        <el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="qh_list_form.goods_name" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="qh_list_form.mobile" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="qhQuery">查询</el-button>
                    <el-button @click="qhExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="qh_list">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column prop="goods_name" label="商品名称"></el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="quantity" label="取酒数量"></el-table-column>
                <el-table-column prop="buying_price" label="进货单价"></el-table-column>
                <el-table-column prop="buying_price_total" label="进货价合计"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-4">取酒总量:</label>
                    <div class="list-total">{{qh_quantity_total}}</div>
                    <label class="list-label-4">进货总价:</label>
                    <div class="list-total">{{qh_buying_price_total}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="qh_list_page"
                    :total="qh_list_total"
                    @current-change="getQhList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="qh_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="qh_export_sign" v-model="qh_export_all" @change="qhExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="qh_export_ids" @change="qhExportChange">
                    <el-checkbox label="shop_name">门店</el-checkbox>
                    <el-checkbox label="goods_type_name">商品类型</el-checkbox>
                    <el-checkbox label="goods_name">商品名称</el-checkbox>
                    <el-checkbox label="goods_unit_name">单位</el-checkbox>
                    <el-checkbox label="quantity">取酒数量</el-checkbox>
                    <el-checkbox label="buying_price">进货单价</el-checkbox>
                    <el-checkbox label="buying_price_total">进货价合计</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="qh_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="qh_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_area_list: [],
                goods_type_list: [],
                qh_list_form: {
                    start_date: '',
                    end_date: '',
                    shop_id: '',
                    room_area: '',
                    room_area_name: '',
                    room_area_disabled: false,
                    goods_type: '',
                    goods_name: '',
                    mobile: '',
				},
				qh_list: [],
				qh_list_page: 1,
                qh_list_total: 0,
                qh_export_sign: false,
				qh_export_all: false,
                qh_export_ids: [],
                qh_export_list: ['shop_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'quantity', 'buying_price', 'buying_price_total'],
                qh_export_type: '1',
                qh_quantity_total: '',
                qh_buying_price_total: '',
            }
        },
        mounted: function() {
            // 日期
            this.qh_list_form.start_date = moment().format('YYYY-MM-DD 08:00');
            this.qh_list_form.end_date = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.qh_list_form.shop_id = this.shop_list[0].id;
                this.getRoomArea(this.shop_list[0].id);
                this.getGoodsType();
                this.getQhList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.qh_list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.qh_list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.qh_list_form.start_date = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.qh_list_form.end_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.qh_list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.qh_list_form.start_date = start.format('YYYY-MM-DD 08:00');
                    _this.qh_list_form.end_date = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;

                if(shop_id == '') {
                    _this.qh_list_form.room_area = '';
                    _this.qh_list_form.room_area_name = '';
                    _this.qh_list_form.room_area_disabled = true;
                } else {
                    _this.qh_list_form.room_area = '';
                    _this.qh_list_form.room_area_name = '';
                    _this.qh_list_form.room_area_disabled = false;
                    _this.setShopDefaultTime(shop_id);
                    Vue.axios.post('Shop/getRoomArea', {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "shop_id": shop_id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            _this.room_area_list = res.data.response.result;
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                }
            },
            // 商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },



            qhRoomArea(val) {
				this.qh_list_form.room_area = val.id;
				this.qh_list_form.room_area_name = val.name;
			},
            getQhList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('FinanceReport/getTakeDepositSumList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.qh_list_form.start_date,
                            "end_date": _this.qh_list_form.end_date,
							"shop_id": _this.qh_list_form.shop_id,
							"room_area": _this.qh_list_form.room_area || '',
							"goods_type": _this.qh_list_form.goods_type,
							"goods_name": _this.qh_list_form.goods_name,
							"mobile": _this.qh_list_form.mobile
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.qh_list_total = Number(res.data.response.result.count);
							_this.qh_quantity_total = res.data.response.result.quantity_total;
							_this.qh_buying_price_total = res.data.response.result.buying_price_total;
						}
						_this.qh_list = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			qhQuery() {
				this.getQhList(1);
            },
            // 导出
            qhExportAll(val) {
				this.qh_export_ids = val ? this.qh_export_list : [];
				this.qh_export_sign = false;
			},
			qhExportChange(val) {
				const len = val.length;
				this.qh_export_all = len === this.qh_export_list.length;
				this.qh_export_sign = len > 0 && len < this.qh_export_list.length;
			},
            qhExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "FinanceReport/takeDepositSumExport?bill_type=take_deposit"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.qh_export_ids = res.data.response.result.export_fields;
                            _this.qh_export_type = res.data.response.result.export_type;
                        } else {
                            _this.qh_export_ids = _this.qh_export_list;
                            _this.qh_export_type = '1';
                        }
                        _this.qhExportChange(_this.qh_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });
                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.qh_list_export)
                }, function() {
                    _this.qhExport();
                });
            },
            qhExport: function() {
                window.location.href = Vue.ctUrl + "FinanceReport/takeDepositSumExport?bill_type=take_deposit" +
                    "&start_date=" + this.qh_list_form.start_date +
                    "&end_date=" + this.qh_list_form.end_date +
                    "&shop_id=" + this.qh_list_form.shop_id +
                    "&room_area=" + (this.qh_list_form.room_area || '')+
                    "&room_area_name=" + (this.qh_list_form.room_area_name || '') +
                    "&goods_type=" + this.qh_list_form.goods_type +
                    "&goods_name=" + this.qh_list_form.goods_name +
                    "&mobile=" + this.qh_list_form.mobile +
                    "&export_fields=" + JSON.stringify(this.qh_export_ids) +
                    "&export_type=" + this.qh_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>